import React, { createContext, useContext, useState, ReactNode } from 'react';
import ReactDOM from 'react-dom';
import { Toast, ToastContainer, Button } from 'react-bootstrap';
import { UilTimes } from '@iconscout/react-unicons';

interface ToastContextType {
    showToast: (title: string, message: string) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider = ({ children }: { children: React.ReactNode }) => {
    const [show, setShow] = useState(false);
    const [toastTitle, setToastTitle] = useState('');
    const [toastMessage, setToastMessage] = useState('');

    const showToast = (title: string, message: string) => {
        setToastTitle(title);
        setToastMessage(message);
        setShow(true);
    };

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}

            {ReactDOM.createPortal(
                <ToastContainer
                    className="position-fixed top-0 end-0 p-3"
                    style={{ zIndex: 9999 }}
                >
                    <Toast onClose={() => setShow(false)} show={show} delay={3000} autohide>
                        <Toast.Header closeButton={false}>
                            <strong className="me-auto">{toastTitle}</strong>
                            <Button className="ms-2 p-0" onClick={() => setShow(false)}>
                                <UilTimes className="fs-7" />
                            </Button>
                        </Toast.Header>
                        <Toast.Body>{toastMessage}</Toast.Body>
                    </Toast>
                </ToastContainer>,
                document.body
            )}
        </ToastContext.Provider>
    );
};


export const useToast = (): ToastContextType => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
};
